/**
 * Client-side static profanity filter (English + Korean substring match).
 * Extend BAD_WORDS_EN / BAD_WORDS_KO as needed. Not a substitute for server-side moderation.
 * Keep lists in sync with pony/supabase/functions/_shared/staticProfanityFilter.ts (Edge).
 */

/** @type {readonly string[]} */
const BAD_WORDS_EN = [
  'fuck',
  'fuk',
  'fck',
  'shit',
  'bitch',
  'bastard',
  'asshole',
  'dick',
  'cunt',
  'piss',
  'slut',
  'whore',
  'motherfucker',
  'bullshit',
  'dammit',
  'goddamn',
];

/** @type {readonly string[]} */
const BAD_WORDS_KO = [
  '시발',
  '씨발',
  '시팔',
  'ㅅㅂ',
  'ㅆㅂ',
  '병신',
  'ㅂㅅ',
  '좆',
  '개새',
  '개새끼',
  '지랄',
  'ㅈㄹ',
  '니미',
  '엿먹',
  '꺼져',
  '죽어',
  '새끼',
  '미친',
  '븅신',
  '등신',
];

/**
 * @param {string} raw
 * @returns {boolean}
 */
export function containsBlockedProfanity(raw) {
  const text = String(raw ?? '');
  if (!text.trim()) return false;

  const normalized = text.normalize('NFC');
  const lowered = normalized.toLowerCase();
  const compactLatin = lowered.replace(/[\s_\-.*]+/g, '');
  const compactKo = normalized.replace(/\s/g, '');

  for (const w of BAD_WORDS_EN) {
    if (!w) continue;
    const lw = w.toLowerCase();
    if (lowered.includes(lw) || compactLatin.includes(lw.replace(/\s/g, ''))) return true;
  }

  for (const w of BAD_WORDS_KO) {
    if (!w) continue;
    if (normalized.includes(w) || compactKo.includes(w.replace(/\s/g, ''))) return true;
  }

  return false;
}
